import { ListFilter } from "lucide-react";
import { useDropdownVisibility } from '../../../hooks/useDropdownVisibility';
import { getTeamLogo } from "../../../../../static/logos/TeamLogos";
import "../MatchFilter.css";

export default function ClubFilter({ clubList, allMatches, setDisplayMatches, setDayFilter, setClubFilter, clubInfo, filterByClub}) {
  const { refs, toggleDropdown, visibilityState } = useDropdownVisibility(["club"]);
  return (
    <div
      className="spiele-page__filter spiele-page__filter-club"
      ref={refs.club}
    >
      <button
        onClick={() => toggleDropdown("club")}
      >
        <h3>
          <ListFilter /> CLUBS
        </h3>
      </button>

      {visibilityState.club && (
        <div className="dropdown-menu">
          <ul>
            <li>
              <button
                onClick={() => {
                  setClubFilter(null);
                  setDayFilter(null);
                  setDisplayMatches(allMatches);
                  toggleDropdown("club");
                }}
              >
                Alle Clubs
              </button>
            </li>
            {clubList.map((club) => (
              <li key={club}>
                <button
                  onClick={() => {
                    filterByClub(club);
                    toggleDropdown("club");
                  }}
                >
                  <div className="spiele-page__filter-logo">
                    <img
                      src={getTeamLogo(club)}
                      alt={`${club.away_team} logo`}
                    />
                  </div>
                  {
                    clubInfo.find(
                      (clubee) => clubee.clubee_name === club,
                    )?.details.club_name
                  }
                </button>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}
